// extracted by mini-css-extract-plugin
export default {"glass-container":"detail_glass-container__oim8S","glass":"detail_glass__DZZw3","content":"detail_content__D8ewl"};